import angular from 'angular';

import { LandingController } from './controllers/landingController';
import { LocationPickerComponent } from './directives/locationPickerComponent';
import { AlreadyLoggedInComponent } from './directives/already_logged_in.component';
import { StartLoginComponent } from './directives/start_login.component';
import { StartOrderComponent } from './directives/start_order.component';

export const LandingModule = angular
    .module('oo.landing', [])
    .controller('landingController', LandingController)
    .component('locationPicker', LocationPickerComponent)
    .component('alreadyLoggedIn', AlreadyLoggedInComponent)
    .component('startLogin', StartLoginComponent)
    .component('startOrder', StartOrderComponent)
    .name;
